import apiClient, { buildQueryParams } from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

/**
 * Service for Vehicle Features API calls
 */
const vehicleFeatureService = {
  /**
   * Get all vehicle features with pagination and filters
   */
  getAllFeatures: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 50,
        search = '',
        status = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_FEATURES.LIST}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFeatureService.getAllFeatures'));
    }
  },

  /**
   * Get a single vehicle feature by ID
   */
  getFeatureById: async (id) => {
    try {
      return await apiClient.get(API_ENDPOINTS.VEHICLE_FEATURES.GET_BY_ID(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFeatureService.getFeatureById'));
    }
  },

  /**
   * Create a new vehicle feature
   */
  createFeature: async (featureData) => {
    try {
      return await apiClient.post(API_ENDPOINTS.VEHICLE_FEATURES.CREATE, featureData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFeatureService.createFeature'));
    }
  },

  /**
   * Update a vehicle feature
   */
  updateFeature: async (id, featureData) => {
    try {
      return await apiClient.put(API_ENDPOINTS.VEHICLE_FEATURES.UPDATE(id), featureData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFeatureService.updateFeature'));
    }
  },

  /**
   * Delete a vehicle feature
   */
  deleteFeature: async (id) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_FEATURES.DELETE(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFeatureService.deleteFeature'));
    }
  },

  /**
   * Delete multiple vehicle features
   */
  deleteMultipleFeatures: async (ids) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_FEATURES.DELETE_MULTIPLE, { data: { ids } });
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFeatureService.deleteMultipleFeatures'));
    }
  },

  /**
   * Toggle feature status
   */
  toggleFeatureStatus: async (id) => {
    try {
      return await apiClient.patch(API_ENDPOINTS.VEHICLE_FEATURES.TOGGLE_STATUS(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFeatureService.toggleFeatureStatus'));
    }
  },
};

export default vehicleFeatureService;
